import { get } from "lodash";
import { UNITS } from "./formula-units";
import { MetricsKind } from "../types";
import { sumColumnValues } from "../sibling-value-getter/getter";
import { safeParseFloat } from "lib/number";
import { BULK_IDENTIFIER } from "components/product-collection/product-collection-views/product-collection-grid-view/detail-list/helpers";

export const UNIT_ROW_PERCENTAGE_PLAN = ({ factoryOptions, getterParams }) => {
    if (factoryOptions.useSize || get(getterParams, "node.data.type") === BULK_IDENTIFIER) {
        return undefined;
    }

    const unitsColumnValuesSum = sumColumnValues(MetricsKind.UNITS, factoryOptions, getterParams);
    const currentUnits = safeParseFloat(UNITS({ factoryOptions, getterParams }), 0);

    if (unitsColumnValuesSum > 0) {
        return (currentUnits / unitsColumnValuesSum) * 100;
    }

    return undefined;
};
